import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RicercaComponentRoutingModule } from './ricerca-component-routing.module';
import { RicercaComponent } from 'src/app/component/ricerca/ricerca.component';



















@NgModule({
    imports: [
    CommonModule,
    RicercaComponentRoutingModule,
    RicercaComponent
]
})
export class RicercaComponentModule { }
